<template>
  <VContainer fluid>
    <div class="d-none d-lg-block ma-16 pa-16" v-html="$t('privacy')"></div>
    <div class="d-lg-none" v-html="$t('privacy')"></div>
  </VContainer>
</template>

<script>
export default {
  name: 'Privacy',
  mounted() {
    if (this.$route?.params?.lang) {
      this.$i18n.locale = this.$route.params.lang
    }
  }
}
</script>
